import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {IconButton} from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import {toggleChat} from '../../features/Insights/chatSlice';

function ChatToggleButton() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isOpen = useSelector((state) => {
    return state.chat.isOpen;
  });

  // Don't show button on Insights page (it has its own chat interface)
  if (location.pathname === '/insights') {
    return null;
  }

  // When panel is open, close is in the panel's input bar; hide floating button to avoid overlap
  if (isOpen) {
    return null;
  }

  return (
    <IconButton
      data-chat-toggle
      color='primary'
      title='Insights assistant'
      onClick={() => {
        return dispatch(toggleChat());
      }}
      sx={{
        padding: '6px',
        marginRight: '2px',
        '& .MuiSvgIcon-root': {
          fontSize: '1.75rem',
        },
      }}
    >
      <ChatIcon />
    </IconButton>
  );
}

export default ChatToggleButton;
